import {Controller} from "react-hook-form";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";

interface FormRadioProps<T> {
  control: any;
  name: string;
  defaultValue?: T;
  onChange?: () => void;
  options: { value: T; label: string }[];
}

export function FormRadio<T>({
                               control,
                               name,
                               defaultValue,
                               onChange,
                               options
                             }: FormRadioProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({field: {onChange: fieldOnChange, value}}) => (
        <FormControl>
          <RadioGroup
            row
            value={value}
            onChange={(event, checked) => {
              fieldOnChange(event, checked);
              onChange?.();
            }}
          >
            {
              options.map(option => (
                <FormControlLabel
                  key={`form-radio-buttons-${option.value}`}
                  value={option.value}
                  control={<Radio/>}
                  label={option.label}
                />
              ))
            }
          </RadioGroup>
        </FormControl>
      )}
    />
  );
}
